<!--右边tab  基本数据信息-->
<template>
	<div class="right-conf">
		<div class="operate-area">
			<div class="exam-ope">
				<div class="info-ope">
					<i class="iconfont iconbiaotianniu" v-if="activeTab === 'title'"></i>
					<div class="exam-no" v-else-if="activeTab === 'examNo'">
						<div
							class="exam-list"
							v-for="item in examNoList"
							:key="item.name"
							@click="choseExamArea(item)"
							:class="{ 'exam-disable': item.isValid, 'list-active': item.value === examActive }"
						>
							{{ item.name }}
							<i v-show="item.isValid" class="iconfont iconbuzhichi"></i>
						</div>
					</div>
					<div class="object-ope" v-else-if="activeTab === 'objective'">
						<el-radio-group v-model="objDirection" size="mini" @change="objRadioDirectionChange">
							<div class="object-origin">客观题题号方向：</div>
							<div style="display: flex;justify-content: space-between;padding: 0 3px">
								<el-radio label="V" border>竖向</el-radio>
								<el-radio label="H" border>横向</el-radio>
							</div>
						</el-radio-group>
						<el-radio-group v-model="fillDirection" size="mini" @change="objFillDirectionChange">
							<div class="object-origin">填涂框排列方向：</div>
							<div style="display: flex;justify-content: space-between;padding: 0 3px">
								<el-radio label="V" border>竖向</el-radio>
								<el-radio label="H" border>横向</el-radio>
							</div>
						</el-radio-group>
						<div>
							<div class="object-origin object-list-title">客观题列表:</div>
							<div
								class="subject-object-list"
								v-for="(objVal, objKey, objIndex) in objectiveItemList"
								:class="{ 'list-active': objectiveChose.includes(objKey) }"
								@click="handleObjective(objVal, objKey, objIndex)"
								:key="objIndex"
							>
								<span>{{ objKey }}:</span>
								<div>
									<span v-for="(item, index) in objVal" :key="`${objIndex}-${index}`">{{ item.smallTopic }}，</span>
								</div>
							</div>
						</div>
					</div>
					<div class="subject-ope" v-else-if="activeTab === 'subjective'">
						<el-divider content-position="left">主观题列表</el-divider>
						<div
							class="subject-object-list"
							v-for="(subItem, subIndex) in subjectiveItemList"
							@click="handleSubjective(subItem, subIndex)"
							:class="{ 'list-active': subjectiveChose === subIndex }"
							:key="subIndex"
						>
							<div>[{{ subItem.paperRangeId }}]{{ subItem.name }}</div>
							<span v-for="(item, index) in subItem.items" :key="`${subIndex}-${index}`">
								{{ `${item.bigTopic}、${item.smallTopic}` }}
							</span>
						</div>
					</div>
					<div class="subject-ope" v-else-if="activeTab === 'choose'">
						<div>
							<div class="subject-title">框选选做题题号:</div>
							<div
								class="subject-object-list"
								v-for="(val, key, index) in resultSelArr"
								:key="key"
								@click="handleOperateSel(val, key, index)"
								:class="{ 'list-active': currentSelKey === key }"
							>
								<div style="text-align: left">选做题 {{ index + 1 }}:</div>
								<div v-for="(item, index) in val" :key="`${key}-${index}`">
									<span v-for="(smVal, smIndex) in item.items" :key="`${key}-${index}-${smIndex}`" :title="smVal.pkId">
										{{ `${smVal.bigTopic}.${smVal.smallTopic}` }}
									</span>
								</div>
							</div>
						</div>
						<div>
							<div class="subject-title">框选选做题答题区:</div>
							<div
								class="subject-object-list"
								v-for="(val, key, index) in resultSelArr"
								:key="key"
								@click="handleChoose(val, index)"
								:class="{ 'list-active': currentChooseIndex === index }"
							>
								<div style="text-align: left">选做题 {{ index + 1 }}:</div>
								<span v-for="(item, index) in val" :key="`${key}-${index}`">
									<i v-for="(smVal, smIndex) in item.items" :key="`${key}-${index}-${smIndex}`">
										{{ `${smVal.bigTopic}.${smVal.smallTopic}` }}，
									</i>
								</span>
							</div>
						</div>
					</div>
					<div class="exam-paper" v-else-if="activeTab === 'slice'">
						<el-divider content-position="left">原卷切块</el-divider>
						<div class="paper-wrap">
							<div
								class="paper-list"
								v-for="(item, index) in allPaperList"
								:key="index"
								@click="chosePaper(item, index)"
								:class="{ 'paper-active': slicePaperIndex === index }"
							>
								<span v-if="item.name">{{ item.name }}：</span>
								<span v-else>{{ `${item.bigTopic}大题${item.smallTopic}小题` }}</span>
								<div v-if="item.items">
									<span v-for="(val, valIndex) in item.items" :key="`${item.name}-${valIndex}`">
										{{ `${val.bigTopic}.${val.smallTopic},` }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="info-btn">
					<el-button type="primary" size="mini" @click="operatePagePrev" style="background: #009688;border:#009688 ">上一页</el-button>
					<el-button type="success" size="mini" @click="operatePageNext" style="background: #FFB800;border:#ff6f1b ">下一页</el-button>
				</div>
			</div>
			<ul class="ope-area" style="padding-top: 5px;display: flex;flex-direction: column;align-items: center">
				<el-dropdown class="ope-link-list" split-button @click="scalePage" @command="dropMenuCommandLarge" size="small">
					<span class="el-dropdown-link">扩大 </span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in scaleList" :command="item" :key="item">{{ item }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown class="ope-link-list" split-button @click="miniPage" @command="dropMenuCommandMini" size="small">
					<span class="el-dropdown-link"> 缩小 </span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in scaleList" :command="item" :key="item">{{ item }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<li
					class="ope-list"
					:class="tempReferTabState ? 'refer-active' : ''"
					@click="choseReferenceTemp"
					v-show="activeTab === 'objective' || activeTab === 'examNo'"
				>
					选取参考模板
				</li>
				<li class="ope-list" @click="viewOriginalPage">预览</li>
				<li class="ope-list" @click="resetTemplate" style="background: #FF5722; border: #ff6f1b">重置</li>
				<li class="ope-list" size="medium" @click="completeCheck" style="background: #FF5722; border: #ff6f1b">校验完成</li>
				<li class="ope-list" size="medium" @click="goBack" style="background: #009688; border: #009688">返回</li>
			</ul>
		</div>
	</div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { objTopicSorted } from '../utils/js/enum'
export default {
	name: 'right-nav',
	data() {
		return {
			//考号有两种方式
			examNoList: [
				{ name: '考号填涂区', isValid: false, value: 1 },
				{ name: '考号一维码', isValid: false, value: 3 }
			],
			//扩大答题卡的步长
			scaleList: [0.1, 0.5, 1, 2, 3, 5],
			//考号 选择的方式
			examActive: 1,
			//客观题选中列表
			objectiveChose: [],
			//主观题选中的是哪个题块
			subjectiveChose: -1,
			//选做题选中的是哪个题块
			currentChooseIndex: -1,
			//当前框选的是那种类型的题
			activeTab: 'title',
			query: this.$route.query,
			//选择题列表  来自后端
			objectiveItemList: {},
			//主观题列表 来自后端
			subjectiveItemList: [],
			//选做题列表了 数据来自后端
			chooseItemList: [],
			//no use
			imgSrc: '',
			//当前页 答题卡
			currentPage: 1,
			//no use
			editOverviewState: false,
			//一共有几页  答题卡
			imgLen: 0,
			//题目类型
			areaType: 2,
			//no use
			temporaryRectExamNo: {},
			//no use
			temporaryRectObjective: {},
			//选取选做题列表
			resultSelArr: {},
			//主观题列表  来自后端
			subjectiveList: [],
			//答题卡 在第几页
			tempInitPage: 1,
			//原卷切块 题块索引
			slicePaperIndex: null,
			//选做题 选中项
			currentSelKey: null,
			//客观题 选中项
			objectiveChoseIndex: [],
			//websockets
			socket: '',
			//缩放步长
			miniStep: 0.1,
			largeStep: 0.1,
			//	原卷列表
			allPaperList: [],
			//客观题框选方向
			objDirection: 'V',
			//填涂框排列方向
			fillDirection: 'H',
			pageLoad: true
		}
	},
	watch: {
		tabActive(val) {
			let type = {
				title: 2,
				examNo: 8,
				objective: 16,
				subjective: 32,
				slice: 64,
				choose: 128,
				lack: 258
			}
			this.areaType = type[val]
			this.activeTab = val
			if (val === 'slice') this.getSliceList()
		},
		tempObjDirection: {
			handler(val) {
				this.objDirection = val
			},
			immediate: true
		},
		tempScalePage(val) {
			this.tempInitPage = val
		},
		tempImgZoomRate() {
			if (this.pageLoad) {
				this.initScale()
				this.pageLoad = false
			}
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'tempLack',
			'tabActive',
			'tempObjTopic',
			'tempScalePage',
			'tempRectTitle',
			'tempChooseList',
			'tempReferTabState',
			'tempEditImgInfo',
			'tempImgZoomRate',
			'tempObjDirection',
			'tempRectObjective',
			'tempRectSliceList',
			'tempRectExamNoInfo',
			'tempRectSubjective'
		])
	},
	created() {
		this.setTempExamNoType(1)
		this.getObjectiveList()
		this.getSubjectiveList()
	},
	methods: {
		...mapActions('examination/databases', ['get', 'set', 'del']),
		...mapMutations('examination/configation', [
			'setTempSubList',
			'setTempObjTopic',
			'setTempFlushData',
			'setTempReferTabState',
			'setTempScalePage',
			'setOperateCurPage',
			'setTempExamNoType',
			'setTempSliceTopic',
			'setTempSelLikeSub',
			'setChooseTabState',
			'setTempObjSelMeans',
			'setTempObjTabState',
			'setTempSubTabState',
			'setTempHandleReset',
			'setTempInitObjTopic',
			'setTempObjDirection',
			'setTempFillDirection',
			'setTempReferAreaState',
			'setTempSelLikeSubOrObj',
			'setTempTopicCurrentIndex',
			'setTempSelLikeSubOrObjVal',
			'setTempSelLikeSubOrObjName'
		]),
		// 原卷切块 按照题块切
		getSliceList() {
			this.getObjectiveList(true)
		},
		// 获取 客观题 模块
		getObjectiveList(isSlice) {
			const params = {
				examId: this.query.examId,
				subjectId: this.query.subjectId
			}
			this.$get('Cv/getPaperText', params).then(res => {
				console.log(res.data)
				if (isSlice) {
					this.allPaperList = res.data
					return
				}
				let curObjTopic = {}
				this.allPaper = res.data
				res.data.forEach(resp => {
					if (resp.topicMold == 2) {
						if (!curObjTopic[resp.bigTopic]) curObjTopic[resp.bigTopic] = []
						curObjTopic[resp.bigTopic].push(resp)
					}
				})
				this.objectiveItemList = {}
				objTopicSorted.forEach(res => {
					for (let key in curObjTopic) {
						let sum = curObjTopic[key].reduce((acc, val) => (acc += val.score), 0)
						if (res === key) this.objectiveItemList[`${res}大题 (${sum}分)`] = curObjTopic[key]
					}
				})
				let ObjState = Object.keys(this.objectiveItemList).length > 0 ? true : false
				this.setTempObjTabState(ObjState)
			})
		},
		// 获取 主观题 或者 选做题
		getSubjectiveList() {
			const params = {
				examId: this.query.examId,
				subjectId: this.query.subjectId
			}
			let subCodeList = []
			this.$get('Cv/getPaperTask', params).then(res => {
				res.data.forEach(resp => {
					if (resp.items[0].checkType === 0) {
						let sum = resp.items.reduce((acc, val) => (acc += val.score), 0)
						resp.name = `${resp.name}(${sum}分):`
						this.subjectiveItemList.push(resp)
					} else if (resp.items[0].checkType === 1) {
						this.chooseItemList.push(resp)
						resp.items.forEach(element => {
							subCodeList.push(element.subCode)
						})
					}
				})
				//主观题 tab 是否显示
				let subState = this.subjectiveItemList.length > 0 ? true : false
				this.setTempSubTabState(subState)

				subCodeList = new Set(subCodeList)
				let resultSelArr = {}
				Array.from(subCodeList).forEach(res => {
					if (!resultSelArr[res]) resultSelArr[res] = []
					this.chooseItemList.forEach(resp => {
						if (res === resp.items[0].subCode) {
							resultSelArr[res].push(resp)
						}
					})
				})

				this.resultSelArr = resultSelArr
				let chooseState = this.chooseItemList.length > 0 ? true : false
				// 选做题tab 是否显示
				this.setChooseTabState(chooseState)
			})
		},
		// 考号设置
		choseExamArea(val) {
			if (val.isValid) {
				this.$message({ type: 'warning', message: `${val.name}暂不支持`, duration: 3000 })
				return false
			}
			this.$message(`设置考号方式：${val.name}`)
			this.examActive = val.value
			this.setTempExamNoType(val.value)
		},
		//    选中客观题
		async handleObjective(objVal, objKey, objIndex) {
			let hasObjTopic = this.tempObjTopic
			if (this.objectiveChose.includes(objKey)) {
				let index = this.objectiveChose.indexOf(objKey)
				this.$delete(this.objectiveChose, index)
				this.$delete(this.objectiveChoseIndex, index)
				this.$delete(hasObjTopic, index)
			} else {
				hasObjTopic.push({ key: objKey, val: Object.values(objVal) })
				this.objectiveChoseIndex.push(objIndex)
				this.objectiveChose.push(objKey)
			}
			this.setTempObjTopic(hasObjTopic)
			this.setTempTopicCurrentIndex(this.objectiveChoseIndex)
			if (this.objectiveChose.length) this.$message(`正在设置${this.objectiveChose}大题`)
		},
		// 客观题 对其方式
		objRadioDirectionChange(val) {
			if (val === 'V') this.fillDirection = 'H'
			this.setTempObjDirection(val)
			this.setTempFillDirection(this.fillDirection)
		},
		objFillDirectionChange(val) {
			if (val === 'V') this.objDirection = 'H'
			this.setTempFillDirection(val)
			this.setTempObjDirection(this.objDirection)
		},

		// 选中主观题
		handleSubjective(item, index) {
			this.subjectiveChose = index
			this.$message(`设置主观题，${item.name}`)
			this.setTempSubList(item)
		},
		// 选中 选做题 list
		handleChoose(item, index) {
			this.currentChooseIndex = index
			this.currentSelKey = null
			this.setTempSelLikeSubOrObj('sub')
			this.setTempSelLikeSub(item)
		},

		//选中 选取选做题 title
		handleOperateSel(val, key, index) {
			this.currentSelKey = key
			this.currentChooseIndex = null
			this.setTempSelLikeSubOrObj('obj')
			this.setTempSelLikeSubOrObjName(`选做题${index + 1}`)
			this.setTempSelLikeSubOrObjVal(val)
		},
		//重置篇日志
		resetTemplate() {
			const type = {
				2: this.tempRectTitle,
				8: this.tempRectExamNoInfo,
				16: this.tempRectObjective.val,
				32: this.tempRectSubjective,
				64: this.tempRectSliceList,
				128: this.tempChooseList,
				256: this.tempLack
			}
			let ObjList = type[this.areaType]
			this.$confirm('确定重新配置当前步骤?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const len = ObjList.length
				ObjList.forEach((res, index) => {
					this.resetCurrentTemp(res.pkId, len, index)
				})
				this.setTempInitObjTopic({ val: Math.round() })
				console.log('000000')
			})
		},
		// 选取参考模板
		choseReferenceTemp() {
			this.setTempReferTabState(!this.tempReferTabState)
		},
		// 重置配置
		resetCurrentTemp(ppiId, len, currentIndex) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				ppiId
			}
			this.$post('Cv/rmPpi', params).then(() => {
				if (currentIndex === len - 1) {
					this.setTempFlushData({ state: true })
					this.setTempHandleReset({ val: Math.round() })
					this.$message({ type: 'success', message: '删除成功' })
				}
			})
		},
		// 查看原图
		viewOriginalPage() {
			let totalImg = []
			for (let i = 1; i <= this.tempEditImgInfo.len; i++) {
				totalImg.push(
					`/Cv/getRectOn?areaType=0&pading=0&examId=${this.query.examId}&subjectId=${this.query.subjectId}&version=${this.tempEditImgInfo.versionId}&page=${i}`
				)
			}
			this.$viewerApi({
				images: totalImg
			})
		},
		// 完成校验
		completeCheck() {
			this.$confirm('是否完成校验?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.checkComplete()
			})
		},
		// 完成校验 配置
		checkComplete() {
			const params = {
				subjectId: +this.query.subjectId,
				examId: +this.query.examId,
				version: +this.tempEditImgInfo.versionId
			}
			let unSave = { 1: '配置超出试卷边界', 2: '标题验证不通过', 8: '考号验证不通过', 128: '选做题校验失败' }
			this.$post('Cv/updateStepAndVerify', params).then(res => {
				if (res.data.result) {
					this.$message.success('验证通过')
					return false
				}
				// 标题  考号
				if (res.data.unType === 1 || res.data.unType === 2 || res.data.unType === 8 || res.data.unType === 128) {
					this.$message.error(unSave[res.data.unType])
					return false
				}
				// 客观题验证失败
				if (res.data.unType === 16) {
					let message = ''
					Object.values(res.data.kgt).forEach(val => {
						if (val.result === 'false') {
							let count = val.count.split('-')
							let plus = Number(count[1]) - Number(count[0])
							message += `客观题${val.bno}.${val.sno}缺少${plus}个选项 <br>`
						}
					})
					this.$message.error({ dangerouslyUseHTMLString: true, message: message, duration: 5000 })
					return false
				}
				//主观题验证失败
				if (res.data.unType === 32) {
					let message = res.data.zgt.reduce((acc, val) => (acc += val.v + ', '), '')
					this.$notify.error({ message: message + '验证失败' })
				}
			})
		},
		initScale() {
			let viewWidth = document.documentElement.offsetWidth - 240
			let initScaleNum
			if (this.tempImgZoomRate.pageWidth <= 2500) {
				initScaleNum = viewWidth / this.tempImgZoomRate.pageWidth
			} else {
				initScaleNum = viewWidth / (this.tempImgZoomRate.pageWidth / 2)
			}
			this.setTempScalePage(initScaleNum)
		},
		//    扩大试卷
		scalePage() {
			this.tempInitPage += this.largeStep
			this.setTempScalePage(this.tempInitPage)
		},
		// 缩小试卷
		miniPage() {
			this.tempInitPage -= this.miniStep
			if (this.tempInitPage < 0.1) this.tempInitPage = 0.1
			this.setTempScalePage(this.tempInitPage)
		},
		// 操作页面  上一页
		operatePagePrev() {
			this.setOperateCurPage({ dir: 'prev' })
		},
		// 操作页面  下一页
		operatePageNext() {
			this.setOperateCurPage({ dir: 'next' })
		},
		//返回
		goBack() {
			window.location.reload()
		},
		// 选择  原题切块
		chosePaper(val, index) {
			let idList = [val.pkId]
			let name = `${val.bigTopic}大题${val.smallTopic}小题`
			this.slicePaperIndex = index
			this.setTempSliceTopic({ idList, name })
		},
		dropMenuCommandLarge(val) {
			this.largeStep = val
		},
		dropMenuCommandMini(val) {
			this.miniStep = val
		}
	}
}
</script>
<style scoped lang="less">
.right-conf {
	width: 100%;
	height: 100%;
	.exam-paper,
	.operate-area {
		width: 100%;
		height: 100%;
		overflow: auto;
	}
	.paper-wrap {
		margin-top: 10px;
		height: calc(100% - 120px);
		overflow: auto;
		&::-webkit-scrollbar {
			width: 10px;
		}
		.paper-list {
			width: calc(100% - 20px);
			margin-left: 15px;
			padding: 5px 10px;
			box-sizing: border-box;
			background: #dddddd;
			border-radius: 8px;
			margin-bottom: 10px;
			color: black;
			&:hover {
				cursor: pointer;
			}
		}
	}
	.exam-ope {
		height: 68%;
		.iconfont {
			font-size: 100px;
			border: 2px solid #c0bdbd;
			padding: 10px;
			display: inline-block;
			color: #c0bdbd;
			border-radius: 8px;
			margin-left: 12px;
			font-weight: 500;
			margin-top: 10px;
		}
		.iconquekaoicon {
			font-size: 140px;
			padding: 5px;
		}
		.exam-no {
			.exam-list {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 10px;
				height: 30px;
				font-size: 12px;
				background: #dddddd;
				margin-bottom: 15px;
				color: black;
				width: 90%;
				margin-left: 5%;
				box-sizing: border-box;
				border-radius: 8px;
				&:hover {
					cursor: pointer;
				}
			}
			.iconbuzhichi {
				font-size: 25px;
				border: none;
				padding: 0;
				margin-top: 0;
				color: white;
			}
			.exam-disable {
				background: #5f5f5f;
			}
		}
		.info-ope {
			margin-top: 5px;
			height: calc(100% - 35px);
			overflow: auto;
			&::-webkit-scrollbar {
				width: 0;
			}
		}
		.info-btn {
			padding-top: 5px;
			display: flex;
			justify-content: space-around;
		}
	}
	.object-ope {
		.object-origin {
			height: 28px;
			line-height: 28px;
			font-size: 12px;
			padding-left: 5px;
			box-sizing: border-box;
		}
		.el-radio {
			margin-right: 0;
		}
		.object-list-title {
			margin-top: 5px;
		}
		.el-tag {
			margin: 0 0 10px 10px;
		}
	}
	.ope-area {
		border-top: 1px solid #ebebeb;
		box-sizing: border-box;
		.ope-list {
			width: 100px;
			height: 28px;
			margin: 5px auto;
			font-size: 12px;
			text-align: center;
			line-height: 28px;
			border: 0px solid #009688;
			background: #009688;
			border-radius: 3px;
			color: white;
			&:hover {
				cursor: pointer;
			}
			&:active {
				background: #ff0000;
			}
		}
		.ope-link-list {
			margin-bottom: 4px;
		}
		.refer-active {
			background: #015b54;
		}
	}
	.subject-title {
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		color: #989898;
		padding-left: 5px;
		box-sizing: border-box;
	}
	.sel-title {
		width: 90%;
		margin-left: 5%;
		background: #009688;
		border-radius: 8px;
		padding: 10px;
		color: white;
		margin-bottom: 10px;
		box-sizing: border-box;
	}
	.subject-object-list {
		font-size: 13px;
		width: 100%;
		background: #dddddd;
		color: black;
		border-radius: 8px;
		padding: 5px;
		box-sizing: border-box;
		line-height: 18px;
		margin-bottom: 5px;
		&:hover {
			cursor: pointer;
		}
	}
	.title {
		font-size: 12px;
		color: #dad7d7;
		padding: 0px 10px 0px 15px;
	}
	.list-active {
		background: #009688 !important;
		color: white !important;
	}
	.paper-active {
		background: #009688 !important;
		color: white !important;
	}
	/deep/.el-radio-button.is-active {
		background: #009688;
	}
	/deep/.el-radio.is-bordered.is-checked {
		border-color: #009688 !important;
	}
	/deep/.el-radio__input.is-checked + .el-radio__label {
		color: #009688 !important;
	}
	/deep/.el-radio__inner {
		border-color: #009688 !important;
	}
	/deep/.el-radio__input.is-checked .el-radio__inner {
		background: #009688 !important;
	}
	/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
		background: #009688;
		border-color: #009688;
	}
	/deep/.el-dropdown-link {
		padding: 0 7px 0 8px;
		color: white;
	}
	/deep/.el-button--default {
		background: #009688;
	}
	/deep/.el-dropdown__icon {
		color: white;
	}
}
</style>
